import ReactGA from 'react-ga4';

const TRACKING_ID = 'G-2BTRF6LX8N'; // Your Google Analytics Measurement ID

export const initGA = () => {
  ReactGA.initialize(TRACKING_ID, {
    gaOptions: {
      siteSpeedSampleRate: 100,
    },
  });
};

export const logPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

export const logEvent = (category, action, label) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};

export default ReactGA;
